import {
  type ErrorCode,
  type PaymentError,
  type ProductError,
  type PurchaseError,
  PurchaseErrorEnum,
} from "@b2bportal/purchase-api";

const STARTS_WITH_UPPERCASE = /^[A-Z]/;

// Errors from PaymentError/ProductError serialize as `{<DiscriminatorTrait>: <CaseClass>, ...dataFields}`.
// Scala fields are camelCase, so the only PascalCase top-level key is the discriminator.
// Returns "<Discriminator>:<Case>" when the discriminator value is a string,
// or just "<Discriminator>" when it isn't, or null if no PascalCase key found.
export const categorizePurchaseInnerError = (value: unknown): string | null => {
  if (!value || typeof value !== "object") return null;
  for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
    if (STARTS_WITH_UPPERCASE.test(key)) {
      return typeof val === "string" ? `${key}:${val}` : key;
    }
  }
  return null;
};

export const purchaseErrorToString = (error: PurchaseError): string => {
  switch (error.Error) {
    case PurchaseErrorEnum.ErrorCode:
      return (error as ErrorCode).code;
    case PurchaseErrorEnum.PaymentError: {
      const paymentError = error as PaymentError;
      return (
        categorizePurchaseInnerError(paymentError.value.value) ??
        JSON.stringify(paymentError.value.value)
      );
    }
    case PurchaseErrorEnum.ProductError: {
      const productError = error as ProductError;
      return (
        categorizePurchaseInnerError(productError.value.value) ??
        JSON.stringify(productError.value.value)
      );
    }
    default:
      return error.Error;
  }
};

export const vrPurchaseErrorsToString = (errors: PurchaseError[]): string =>
  errors.length > 0
    ? errors.map(purchaseErrorToString).join(" - ")
    : "Poll Vacation Rentals Confirmation Details response returned an error and the given error code is not handleable.";
